import styled from 'styled-components';
import { GoToListPageButton, GoToListPageButtonProps } from '../../../../components/common/buttons/GoToListPageButton';
import { SwiperItemContainer } from '../../../../components/common/itemContainer/SwiperItemContainer';

const QUAD_SLIDE_WIDTH = 300;
const QUAD_SLIDE_HEIGHT = 466;

interface DetailQuadSwiperProps {
  title?: string;
  slideItems: JSX.Element[];
  goToButton: GoToListPageButtonProps;
  slideHeight?: number;
}
export const DetailQuadSwiper = ({ title, slideItems, goToButton, slideHeight }: DetailQuadSwiperProps) => {
  return (
    <Wrapper id={'detail-quad-swiper-container'}>
      {title && <Title>{title}</Title>}
      <SwiperItemContainer
        slideItemWidth={QUAD_SLIDE_WIDTH}
        slideItems={slideItems}
        extraElement={{
          width: 150,
          element: (
            <GoToListPageButton
              renderedIn={goToButton.renderedIn}
              itemType={goToButton.itemType}
              height={slideHeight || QUAD_SLIDE_HEIGHT}
            />
          ),
        }}
      />
    </Wrapper>
  );
};

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const Title = styled.h3`
  color: var(--Light-Scheme-Monochrome-black, #232429);

  /* Display/X-Large/xl-bold */
  font-family: Pretendard;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 130%; /* 23.4px */
`;
